import { client } from '@/shared/api'
import type { BaseResponse } from '@/shared/api/http/types'
import type { UserSession } from '../model/session.type'

/**
 * Fetch current user
 */
export async function fetchMe() {
  return client<BaseResponse<UserSession>>('/users/me')
}
